import { mapGetters, mapMutations, mapActions } from 'vuex';
import mvtTextbox from '@/common/components/mvttextbox/mvt-textbox.vue';
import mvtInputNumber from '@/common/components/mvtinputnumber/mvt-inputnumber.vue';
import mvtInputDecimalNumber from '@/common/components/mvtinputdecimalnumber/mvt-inputdecimalnumber.vue';
import mortgage from '@/common/utilities/mortgage';
import mvtListProperty from '@/common/components/mvtlistproperty/mvt-listproperty.vue';
import mapper from '../../../common/store/mapper/index.js';
function getPropertyList(arr, state){
    if(arr && arr.length){
        return arr.map(function(e){
           return mapper.property(e, state);
        });
    }
    return [];
}
export default {
    name: 'mvtNearbyAfford',
    inject: ['$eventBus'],
    components: {
        mvtTextbox,
        mvtInputNumber,
        mvtInputDecimalNumber,
        mvtListProperty,
    },
    props: {
        income: {
            type: Number,
            default: 0,
        },
        state: {
            type: String,
            default: '',
        },
        cityCode: {
            type: String,
            default: '',
        },
        bed: {
            type: Number,
            default: 0,
        },
        bath: {
            type: Number,
            default: 0,
        },
    },
    methods: {
        ...mapActions('glb', ['getHousesBySearchUrl']),
        ...mapMutations('glb', ['updateRentalInfo', 'updateRentalNearbyAffordUrl']),
        toogle() {
            this.active = !this.active;
        },
        fetchNearby() {
            if (this.total && this.getCityCode && this.getState) {
                let cityCode = `${this.getCityCode}-${this.getState.toLowerCase()}/`;
                this.searchUrl = `${cityCode}price-0-${this.total}/bed-0-${this.getBed || 5}/bath-0-${this.getBath || 5}/status-1/sortby-price-desc/`;
                this.updateRentalNearbyAffordUrl(this.searchUrl);
                this.getHousesBySearchUrl({ path: this.cityPath }).then((e) => {
                    this.nearbyData = e.listings ? getPropertyList(e.listings, this.glb) : [];
                    if (this.nearbyData.length >= 0) {
                        this.$emit('update', {
                            total: this.total,
                            monthPay: this.monthPay,
                            downpayRate: this.downpayRate,
                            count: this.nearbyData.length,
                        });
                    }
                    this.updateRentalInfo({ rentals: this.glb.rentals });
                });
            }
        },
        refresh(income, state, cityCode, bed, bath) {
            if (income) {
                this.monthPay = income;
            }
            if (state) {
                this.getState = state;
            }
            if (cityCode) {
                this.getCityCode = cityCode;
            }
            if (bed) {
                this.getBed = bed;
            }
            if (bath) {
                this.getBath = bath;
            }
            this.total = mortgage.getTotalByMonthPay({ monthPay: this.monthPay, downpayment: this.downpayRate / 100, state: this.getState });
        },
    },
    data() {
        return {
            monthPay: this.income || 0,
            downpayment: 0,
            interestRate: 0,
            downpayRate: 20,
            total: 0,
            nearbyData: [],
            searchUrl: '',
            active: false,
            getState: this.state || '',
            getCityCode: this.cityCode || '',
            getBed: this.bed || 0,
            getBath: this.bath || 0,
        };
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        cityPath() {
            return `${this.getCityCode}-${this.getState.toLowerCase()}/`;
        },
    },
    watch: {
        downpayRate(val) {
            let info = mortgage.getMonthPayByTotal({ total: this.total, downpayment: this.downpayRate / 100, state: this.getState });
            this.monthPay = info.monthTotal;
            this.downpayment = info.downpayment;
            this.interestRate = Math.round(info.interestRate * 100).toFixed(2) + '%';
        },
        total(val, oldVal) {
            if (Math.abs(val - oldVal) > 10000) {
                let info = mortgage.getMonthPayByTotal({ total: this.total, downpayment: this.downpayRate / 100, state: this.getState });
                this.downpayment = info.downpayment;
                this.monthPay = info.monthTotal;
                this.interestRate = info.interestRate * 100 + '%';
                setTimeout(() => {
                    this.fetchNearby();
                }, 10);
            }
        },
    },
    mounted() {
        this.refresh(this.income, this.state, this.cityCode, this.bed, this.bath);
    },
};
